{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Sniðmát",
    "DESCRIPTION": "Skoðaðu skilaboðasniðmátin sem samstillt eru úr WhatsApp innhólfunum þínum. Til að búa til eða breyta sniðmáti skaltu gera það hjá þjónustuveitunni þinni.",
    "COUNT": "{n} sniðmát",
    "LEARN_MORE": "Læra meira um WhatsApp sniðmát",
    "SYNC_TEMPLATES": "Samstilla sniðmát",
    "SYNC_SUCCESS": "Samstilling sniðmáta hófst fyrir öll WhatsApp innhólf. Uppfærslur geta tekið nokkrar mínútur.",
    "PARTIAL_SYNC_ERROR": "Samstilling sniðmáta hófst fyrir sum WhatsApp innhólf, en ekki tókst að samstilla önnur.",
    "SYNC_ERROR": "Ekki tókst að hefja samstillingu sniðmáta. Reyndu aftur.",
    "SEARCH_PLACEHOLDER": "Leita að efni eða nafni...",
    "MANAGE_IN_META": "Stjórna í Meta",
    "LOADING": "Hleður WhatsApp sniðmátum...",
    "EMPTY": "Engin WhatsApp sniðmát fundust.",
    "NO_RESULTS": "Engin sniðmát passa við síurnar þínar.",
    "FETCH_ERROR": "Ekki tókst að hlaða WhatsApp sniðmátum. Reyndu aftur.",
    "PARTIAL_FETCH_ERROR": "Ekki tókst að hlaða sumum WhatsApp sniðmátum. Reyndu aftur.",
    "LAST_SYNC_ATTEMPT": "Síðasta tilraun til samstillingar þann {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Ekki sent inn til samþykktar hjá WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Öll innhólf",
      "ALL_LANGUAGES": "Öll tungumál",
      "ALL_TYPES": "Allar tegundir"
    },
    "TYPES": {
      "TEXT": "Texti",
      "IMAGE": "Mynd",
      "VIDEO": "Myndband",
      "DOCUMENT": "Skjal",
      "CALL_TO_ACTION": "Hvatning til aðgerða",
      "COPY_CODE": "Afrita kóða"
    },
    "PREVIEW": {
      "TITLE": "Forskoðun sniðmáts",
      "DESCRIPTION": "Skoðaðu hvernig þetta sniðmát birtist í WhatsApp.",
      "OPEN": "Forskoða {name}",
      "CLOSE": "Loka forskoðun",
      "DETAILS": "Nánari upplýsingar sniðmáts",
      "STATUS": "Staða",
      "TYPE": "Tegund efnis",
      "CATEGORY": "Flokkur",
      "LANGUAGE": "Tungumál",
      "INBOXES": "Innhólf"
    }
  }
}
